import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavContext } from "../../context-api/nav-context";
/* import callout from "../../Assets/Images/homeValues/boiler-callout.png"; */

const HomeValues = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-values" onMouseOver={closeNavbarMenu}>
      <div className="wrapper two-columns">
        <div className="home-values-left">
          <h1 className="title title-value">
            For 24HR Response Call On 0113 467 0278
          </h1>
          <Link to="/boilers" className="btn-hero btn-quote btn-home-values">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
          <article className="home-values-text">
            <h3 className="home-values-subtitle">
              Servicing Over 8000 homes and businesses
            </h3>
            <p className="home-values-p">
              We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.
            </p>
          </article>
        </div>
        <div className="home-values-right">
          <div className="home-values-images">
            <img
              src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_700/v1642186287/AquaHeat/Home%20values/boiler-callout_tpwgsj.webp"
              alt="AquaHeat bolier and plumbing callout services"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeValues;
